import { ApiService } from 'services';
import { SessionService } from 'services';

const URL_MESSAGES = '/messages';

async function getAllMessages(tokenAddress, search, mailbox) {
  const params = new URLSearchParams();
  if (mailbox) params.append('mailbox', mailbox);
  if (search) params.append('search', JSON.stringify(search));

  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `${URL_MESSAGES}/${tokenAddress}?${params.toString()}`,
  })
    .catch(() => [])
    .then((res) => res);
}

async function getMessage(messageId, tokenAddress) {
  return await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `${URL_MESSAGES}/${messageId}/${tokenAddress}`,
  });
}

async function getAttachement(file, tokenAddress) {
  const { REACT_APP_API_URL_SERVICING } = process.env;
  const accessToken = await SessionService.getToken();

  return fetch(
    `${REACT_APP_API_URL_SERVICING}${URL_MESSAGES}/attachment/${file.id}/${tokenAddress}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  )
    .then((res) => res.blob())
    .then((blob) => {
      let anchor = document.createElement('a');
      anchor.href = window.URL.createObjectURL(blob);
      anchor.download = file.filename;
      document.body.appendChild(anchor); // we need to append the element to the dom -> otherwise it will not work in firefox
      anchor.click();
      anchor.remove(); //afterwards we remove the element again
    });
}

export default {
  getAllMessages,
  getMessage,
  getAttachement,
};
